import type { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

interface InfoTipHintProps {
  label: ReactNode;
  children?: ReactNode;
  className?: string;
}

export function InfoTipHint({
  label,
  children,
  className,
}: Readonly<InfoTipHintProps>) {
  return (
    <div
      className={twMerge(
        "border-primary/30 bg-primary/10 text-primary flex items-center gap-2 rounded-md border px-4 py-2 text-sm",
        className,
      )}
    >
      <span className="font-medium whitespace-nowrap">💡 {label}</span>
      {children ? <span>{children}</span> : null}
    </div>
  );
}
